import { routes } from "~/app/routes/web-routes.ts";

export const buildQuoteBoardReturnUrl = (
	pathname: string,
	search: string,
): string => `${pathname}${search}`;

export const getSafeQuoteBoardReturnUrl = (
	returnTo: string | null,
): string | null => {
	if (!returnTo) return null;

	try {
		const parsed = new URL(returnTo, globalThis.location.origin);
		if (parsed.origin !== globalThis.location.origin) return null;
		if (parsed.pathname !== routes.quotes) return null;
		return `${parsed.pathname}${parsed.search}${parsed.hash}`;
	} catch {
		return null;
	}
};

export const addReturnTo = (url: string, returnTo: string): string => {
	const separator = url.includes("?") ? "&" : "?";
	return `${url}${separator}returnTo=${encodeURIComponent(returnTo)}`;
};

export const buildBulkTenderRerateUrl = (
	quoteId: number,
	pathname: string,
	search: string,
): string => {
	return addReturnTo(
		routes.shipmentRerateCarrierSelection.replace(":quoteId", String(quoteId)),
		buildQuoteBoardReturnUrl(pathname, search),
	);
};
